export default "__VITE_ASSET__34699e53__"